import { instance, errorService, savePreviousData } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import {
  calculatePerimeterBuildingFootprint,
  showNotification,
  evaluateQantity,
  convertCalculation,
} from '@/services/calculate'
import {
  updateLockRow,
  updateGridRecord,
  addGridRecord,
  updateConditionFactorGridRecord,
} from '@/services/grid'
import { apiRequest, validateNumber, tableName } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import TakeoffComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Takeoff'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import LockRenderes from '@/components/DynamicComponents/Renderers/lockRenderer'
import QuantityPerRenderer from '@/components/DynamicComponents/Renderers/quantityPerRenderer'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import MasterAutoCompleteRenders from '@/components/DynamicComponents/Renderers/masterAutoCompleteRenderer'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import TakeoffSelectEditor from '@/components/DynamicComponents/Renderers/takeoffSelectEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import FactorEditor from '@/components/DynamicComponents/Renderers/factorEditor'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'category-code': CategoryCodeComponent,
    contract: ContractComponent,
    takeoff: TakeoffComponent,
  },
  props: [
    'propData',
    'tableId',
    'projectModule',
    'tenantSF',
    'type',
    'viewOnly',
    'screenId',
    'columnSettings',
    'isArchive',
  ],
  data() {
    return {
      myScreen: this.propData.screen,
      data: [],
      redrawTable: false,
      loaderAdd: false,
      savePreviousData: savePreviousData,
      firstRowUpdateInfo: this.propData.constructionInfoData
        ? this.propData.constructionInfoData
        : null,
      addConstructionInfo: this.propData.constructionInfo,
      takeOff: this.propData['dropdownData'].takeoff,
      loader: false,
      isAddTakeoff: false,
      loading: false,
      sortedData: [],
      screenNameData: '',
      formGeneral: {
        id: undefined,
        conditionFactorId: undefined,
        constructionQualityFactorId: undefined,
        area: undefined,
        perimeter: undefined,
        label: undefined,
        previousConditionFactorId: undefined,
      },
      rulesformGeneral: {
        constructionQualityFactorId: [
          {
            required: true,
            message: 'Please select construction quality factor',
            trigger: 'change',
          },
        ],
        conditionFactorId: [
          {
            required: true,
            message: 'Please select condition factor',
            trigger: 'change',
          },
        ],
        area: [
          {
            required: true,
            message: 'Please enter area',
            trigger: 'blur',
          },
        ],
        perimeter: [
          {
            required: true,
            message: 'Please enter perimeter',
            trigger: 'blur',
          },
        ],
        label: [
          {
            required: this.propData.screen === 'Grouping Bank',
            message: 'Please enter grouping',
            trigger: 'blur',
          },
        ],
      },
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: false,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        rowDragManaged: true,
        suppressContextMenu: true,
        defaultColDef: {
          resizable: true,
          sortable: true,
          editable: true,
          suppressMovable: true,
          singleClickEdit: true,
          menuTabs: ['filterMenuTab'],
        },
        rowClassRules: {
          // row style function
          lockedRow: function(params) {
            params.editable = false
            return params.data.isLocked
          },
        },
      },
      gridApi: null,
      columnDefs: null,
      frameworkComponents: null,
      tableParams: null,
      postSort: null,
      width: '100%',
      height:
        this.propData.screen === 'Tenant Interior Grouping' ? '320px' : '270px',
      fieldLoader: false,
      fieldName: null,
      changeIndex: undefined,
      selectedRowKeys: [],
      loaderDelete: false,
      isCalculationError: false,
      calculationData: this.propData.calculationData,
      interiorGroupingId: this.propData.firstRowValues
        ? this.propData.firstRowValues.interiorGroupId
        : undefined,
      fieldLabel: this.propData.firstRowValues
        ? this.propData.firstRowValues.label
        : undefined,
      tenantId: this.propData.firstRowValues
        ? this.propData.firstRowValues.tenantId
        : undefined,
      info:
        this.propData.firstRowValues &&
        !this.propData.firstRowValues.interiorGroupId
          ? 'Building'
          : undefined,
      tenantApproachId: this.propData.firstRowValues
        ? this.propData.firstRowValues.tenantApproachId
        : undefined,
      fieldDisabled: false,
      structureProfileId:
        this.propData && this.propData.buildingData
          ? this.propData.buildingData.structureProfileId
          : undefined,
      loaderCopy: false,
      selectedRows: [],
      isBlurCalled: true,
      takeoffDetails: null,
      isAddContract: false,
      isAddCategory: false,
      tableState: null,
      conditionFactorList: this.propData.dropdownData.condition_factor,
      keys: [
        'contract',
        'categoryCode',
        'additionalDescription',
        'takeoff',
        'calculation',
        'quantity',
        'unit',
        'unitCost',
        'multiplier',
        'conditionFactor',
      ],
      checked: false,
      isValidTakeoff: false,
    }
  },
  watch: {
    tenantSF() {
      this.formGeneral.perimeter = calculatePerimeterBuildingFootprint(
        this.tenantSF,
      )
      this.formGeneral.area = this.tenantSF
      this.loading = true
    },
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      this.sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i].data.category_Code) {
          rowNodes[i].data.category_Code = Number(
            rowNodes[i].data.category_Code,
          )
        }
        this.sortedData.push(rowNodes[i].data)
      }
      this.data = this.sortedData
    }
  },
  created() {
    this.formGeneral = this.propData.firstRowValues
    this.formGeneral.previousConditionFactorId = this.formGeneral.conditionFactorId
    this.propData.create.$off('addRecord')
    this.propData.create.$on('addRecord', this.addRecord)
    this.$root.$off('deleteRecord')
    this.$root.$on('deleteRecord', this.deleteRecord)
    this.$root.$on('handleChange', this.onUpdateTakeoff)
    this.checkPerimeter()
  },
  mounted() {
    this.loadingConfig()
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.$root.$on('showLoader', this.showLoader)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('handleChange')
    this.$root.$off('deleteRecord')
    this.data = []
    this.propData.create.$off('addRecord')
    this.$root.$off('showLoader')
    this.$root.$off('displayDropdown')
    this.$root.$off('setTenantData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        customFilter: CustomFilter,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        autocomplete: AutoCompleteRenders,
        quantityPerCellRenderer: QuantityPerRenderer,
        lockRenderer: LockRenderes,
        inputNumberEditor: InputNumberEditor,
        masterAutocomplete: MasterAutoCompleteRenders,
        toolTipRenderer: ToolTipRenderer,
        calculationEditor: CalculationEditor,
        takeoffSelectEditor: TakeoffSelectEditor,
        textEditor: TextEditor,
        factorEditor: FactorEditor,
      }
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLocked) return false
          else return true
        }
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onModelUpdated() {
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    getData(params) {
      Object.assign(this.calculationData, this.propData.buildingData)
      this.propData.rows.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.calculationData,
            this.propData.dropdownData.calculation,
          )
          if (evaluateQantity(element.formula) < 0) {
            element.quantity = element.quantity < 0 ? null : element.quantity
          }
        }
        element.area =
          this.propData.firstRowValues && this.propData.firstRowValues.area
            ? this.propData.firstRowValues.area
            : 0
      })
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.setRowData(this.propData.rows)
      this.isValidTakeoff = this.propData.rows.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 200 + 'px'
      }
      this.columnDefs = displayColumns
      this.getColumnSettings(params, this.propData.rows)
    },

    onUpdateConditionFactor(fieldName, value, field) {
      window.previousValue = this.formGeneral.previousConditionFactorId
      var isPresent = this.data.some(
        e => e.conditionFactorId !== window.previousValue,
      )
      if (isPresent) {
        var that = this
        this.$confirm({
          title: `Do you want to change overridden condition factor?`,
          content: h => (
            <div>
              <p>This action will change the overridden condition factor.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.onUpdate(fieldName, value, field)
          },
          onCancel() {
            that.formGeneral.conditionFactorId = window.previousValue
          },
        })
      } else {
        this.onUpdate(fieldName, value, field)
      }
    },

    onUpdate(fieldName, value, field) {
      let url = null
      let msg = null
      let isValid = true
      const currentValue = !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (previousValue.toString() !== currentValue.toString()) {
        switch (this.propData.screen) {
          case 'Building Shell':
            url = projectAPIs.project.asset.buildingShell.update(
              this.$route.params.id,
              this.propData.assetId,
              this.propData.firstRowValues.id,
            )
            msg = 'Please wait while updating building shell details'
            break
          case 'Site Takeoffs':
            url = projectAPIs.project.asset.siteTakeoff.update(
              this.$route.params.id,
              this.propData.assetId,
              this.propData.firstRowValues.id,
            )
            msg = 'Please wait while updating site takeoff details'
            break
          case 'Speciality Information':
            url = projectAPIs.project.asset.commonArea.update(
              this.$route.params.id,
              this.propData.assetId,
              this.propData.firstRowValues.id,
            )
            msg = 'Please wait while updating common area details'
            break
          case 'Interior Info':
            url = projectAPIs.project.asset.interiorInfo.update(
              this.$route.params.id,
              this.propData.assetId,
              this.propData.firstRowValues.id,
            )
            msg = 'Please wait while updating interior info details'
            break
          default:
            break
        }
        let request = {}
        switch (fieldName) {
          case 'constructionQualityFactorId':
            const constructionfactor = this.propData.dropdownData.construction_quality_factor.find(
              i => i.id === value,
            )
            request = {
              constructionQualityFactorId: value,
              constructionQualityFactor: constructionfactor
                ? constructionfactor.option
                : null,
              ConstructionQualityFactorValue: constructionfactor
                ? constructionfactor.value
                : null,
            }
            break
          case 'conditionFactorId':
            isValid = true
            const factor = this.propData.dropdownData.condition_factor.find(
              i => i.id === value,
            )
            request = {
              conditionFactorId: value,
              ConditionFactor: factor ? factor.option : null,
              ConditionFactorValue: factor ? factor.value : null,
            }
            this.fieldLoader = true
            break
          case 'area':
            isValid = validateNumber(value, fieldName, 'Area')
            if (isValid) {
              this.formGeneral.perimeter = calculatePerimeterBuildingFootprint(
                value || 0,
              )
              request = {
                area: value ? Number(value) : null,
                perimeter: Number(this.formGeneral.perimeter),
              }
            } else {
              this.formGeneral.area = previousValue
            }
            break
          case 'perimeter':
            isValid = validateNumber(value, fieldName, 'Perimeter')
            if (isValid) {
              request = {
                perimeter: value ? Number(value) : null,
              }
            } else {
              this.formGeneral.perimeter = previousValue
            }
            break
          default:
            request = {
              [fieldName]: value ? Number(value) : value,
            }
            break
        }
        if (isValid) {
          this.fieldName = fieldName
          this.fieldLoader = true
          this.$root.$emit('popupUpdation', true, true, msg)
          instance
            .patch(`${url}`, request)
            .then(res => {
              if (fieldName === 'area') {
                let newData = [...this.data]
                newData = newData.map(element => {
                  element.area = value ? Number(value) : value
                  return element
                })
                this.data = [...newData]
                this.gridOptions.api.setRowData(newData)
              } else if (fieldName === 'conditionFactorId') {
                this.formGeneral.previousConditionFactorId = value
                this.resetGridConditionFactor(request)
              }
              this.fieldName = undefined
              this.fieldLoader = false
              Object.assign(request, { id: this.propData.firstRowValues.id })
              if (this.propData.tenant && this.propData.tenant.fieldInfo) {
                Object.assign(request, {
                  fieldInfo: this.propData.tenant.fieldInfo,
                })
              }
              this.$emit('updateBasic', request)
            })
            .catch(err => {
              this.fieldLoader = false
              this.$root.$emit('popupUpdation', false, true, msg)
              errorService(err)
            })
        }
      }
    },

    onUpdateTakeoff(value, record, key, index, takeoffData, data, keyCode) {
      this.changeIndex = index
      const findIndex = this.data.findIndex(val => val.id === record.id)

      if (findIndex > -1) {
        const newData = [...this.data]
        const currentValue =
          value === 0 ? value.toString() : !value ? '' : value
        const previousValue = !window.previousValue ? '' : window.previousValue
        if (
          (currentValue !== null &&
            previousValue.toString() !== currentValue.toString()) ||
          key === 'calculation'
        ) {
          let url
          let enabled = true
          let request
          let isValid = true
          switch (this.propData.screen) {
            case 'Building Shell':
              url = projectAPIs.project.asset.buildingShell.takeoff.update(
                this.$route.params.id,
                this.propData.assetId,
                this.propData.firstRowValues.id,
                record.id,
              )
              break
            case 'Site Takeoffs':
              url = projectAPIs.project.asset.siteTakeoff.takeoff.update(
                this.$route.params.id,
                this.propData.assetId,
                this.propData.firstRowValues.id,
                record.id,
              )
              break
            case 'Speciality Information':
              url = projectAPIs.project.asset.commonArea.takeoff.update(
                this.$route.params.id,
                this.propData.assetId,
                this.propData.firstRowValues.id,
                record.id,
              )
              break
            case 'Interior Info':
              url = projectAPIs.project.asset.interiorInfo.takeoff.update(
                this.$route.params.id,
                this.propData.assetId,
                this.propData.firstRowValues.id,
                record.id,
              )
              break
            default:
              break
          }
          const details = {
            contract: data,
            categoryCode: data,
            record: record,
            list: newData,
            value: value,
            takeoff: takeoffData,
            unit: data,
            key: key,
            propData: this.propData.firstRowValues,
          }
          switch (key) {
            case 'calculation':
              this.loading = true
              request = apiRequest(details, index)
              break
            case 'contract':
              this.takeoffDetails = { ...record }
              if (value === 'addContract') {
                this.isAddContract = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequest(details, index)
              }
              break
            case 'categoryCode':
              this.takeoffDetails = { ...record }
              if (value === 'addCategory') {
                this.isAddCategory = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequest(details, index)
              }
              break
            case 'takeoff':
              this.takeoffDetails = { ...record }
              this.isBlurCalled = false
              if (value === 'new') {
                this.isAddTakeoff = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequest(details, index)
              }
              break
            case 'multiplier':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value || 0, key, 'Multiplier')
              if (isValid) {
                request = apiRequest(details, index)
              }
              break
            case 'quantity':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Quantity')
              if (isValid) {
                request = apiRequest(details, index)
              }
              break
            case 'unitCost':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Unit Cost')
              if (isValid) {
                request = apiRequest(details, index)
              }
              break
            case 'conditionFactor':
              isValid = validateNumber(
                value,
                'conditionFactor',
                'Condition Factor',
              )
              if (isValid) {
                const factor = this.conditionFactorList.find(
                  i => i.value === value,
                )
                this.takeoffDetails = { ...record }
                request = {
                  [key]: value || null,
                  conditionFactorId: factor.id,
                }
              }
              break
            default:
              this.takeoffDetails = { ...record }
              this.loading = true
              request = apiRequest(details, index)
              break
          }
          if (enabled && isValid) {
            this.loading = true
            instance
              .patch(`${url}`, request)
              .then(response => {
                newData[findIndex] = _.get(response.data, 'result', null)
                if (newData[findIndex]) {
                  if (record.formula) {
                    newData[findIndex].formula = record.formula
                  }
                  newData[findIndex].area = this.propData.firstRowValues.area
                  if (
                    key === 'calculation' &&
                    evaluateQantity(record.formula) < 0
                  ) {
                    newData[findIndex].quantity = null
                  }
                }
                this.loading = false
                this.$root.$emit('popupUpdation', false, true, null)
                this.data = [...newData]
                this.gridOptions.api.redrawRows()
                const itemsToUpdate = updateGridRecord(
                  this.gridOptions,
                  record,
                  newData[findIndex],
                )
                this.gridOptions.api.applyTransaction({
                  update: itemsToUpdate,
                })
                this.gridOptions.api.redrawRows()
                this.isValidTakeoff = newData.some(
                  i =>
                    typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
                )
                if (!this.isValidTakeoff && this.checked) {
                  this.sortTakeoffs(this.isValidTakeoff)
                }
                const rowIndex = this.data.findIndex(
                  val => val.id === record.id,
                )
                this.takeoffDetails = null
                this.setActiveCell(key, rowIndex, keyCode)
                if (
                  this.propData.firstRowValues &&
                  this.propData.screen === 'Interior Info'
                ) {
                  this.$emit('updateBuildingFacts', {
                    rowId: this.propData.firstRowValues.id,
                    data: newData,
                    isValidTakeoff: !this.isValidTakeoff,
                  })
                } else {
                  this.$emit(
                    'updateTakeOff',
                    this.data,
                    false,
                    this.propData.firstRowValues.id,
                    !this.isValidTakeoff,
                  )
                }
                this.isBlurCalled = true
              })
              .catch(err => {
                this.loading = false
                this.resetRowData(index)
                if (
                  this.propData.firstRowValues &&
                  this.propData.screen === 'Interior Info'
                ) {
                  this.$emit('updateBuildingFacts', {
                    rowId: this.propData.firstRowValues.id,
                    data: this.data,
                    isValidTakeoff: !this.isValidTakeoff,
                  })
                } else {
                  this.$emit(
                    'updateTakeOff',
                    this.data,
                    false,
                    this.propData.firstRowValues.id,
                    !this.isValidTakeoff,
                  )
                }
                this.$root.$emit('popupUpdation', false, true, null)
                errorService(err)
              })
          } else if (enabled) {
            this.isBlurCalled = true
            setTimeout(() => {
              this.resetRowData(index)
            }, 100)
          }
        } else {
          this.isBlurCalled = true
          if (findIndex === this.data.length - 1 && key === 'multiplier') {
            if (keyCode === 9) {
              this.addRecord()
            }
          }
        }
      }
    },

    newTakeOff(action) {
      this.isAddTakeoff = false
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (action === 'cancel') {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].area = this.propData.firstRowValues.area
        this.data = [...newData]
        this.gridOptions.api.redrawRows()
        const itemsToUpdate = updateGridRecord(
          this.gridOptions,
          this.takeoffDetails,
          newData[index],
        )
        this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      } else {
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      }
      this.takeoffDetails = null
    },

    addContract(data, flag) {
      this.isAddContract = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        this.columnDefs.map(i => {
          if (i.field === 'contract') {
            i.cellRendererParams.dropdownData.contract.push({
              id: data.id,
              masterId: data.masterId,
              option: `${data.contract} - ${data.contractName}`,
              value: `${data.contract} - ${data.contractName}`,
              description: data.contractName,
            })
            i.cellRendererParams.dropdownData.contract = _.orderBy(
              i.cellRendererParams.dropdownData.contract,
              ['contract'],
              ['asc'],
            )
          }
        })
        this.gridOptions.api.setColumnDefs(this.columnDefs)
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.contract,
          this.takeoffDetails,
          'contract',
          index,
          null,
          data,
          null,
        )
        this.$root.$emit('addContract', data)
      } else {
        this.resetRowData(index)
      }
    },

    addCategory(data, contracts, flag) {
      this.isAddCategory = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        const category = {
          id: data.id,
          masterId: data.masterId,
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          contractDetailsId: data.mContractDetailsId,
        }
        this.columnDefs.map(i => {
          if (i.field === 'categoryCode') {
            i.cellRendererParams.dropdownData.category.push(category)
            i.cellRendererParams.dropdownData.category = _.orderBy(
              i.cellRendererParams.dropdownData.category,
              ['id'],
              ['asc'],
            )
          }
          if (contracts && contracts.length > 0) {
            contracts.forEach(element => {
              i.cellRendererParams.dropdownData.contract.push({
                id: element.id,
                masterId: element.masterId,
                option: `${element.contract} - ${element.contractName}`,
                value: `${element.contract} - ${element.contractName}`,
                description: element.contractName,
              })
            })
            i.cellRendererParams.dropdownData.contract = _.orderBy(
              i.cellRendererParams.dropdownData.contract,
              ['contract'],
              ['asc'],
            )
          }
        })
        this.gridOptions.api.setColumnDefs(this.columnDefs)
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.categoryCode,
          this.takeoffDetails,
          'categoryCode',
          index,
          null,
          category,
          null,
        )
        this.$root.$emit('addCategoryCode', category, contracts)
      } else {
        this.resetRowData(index)
      }
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      const isTab = true
      if (isTab && nextCellPosition) {
        result = {
          rowIndex: nextCellPosition.rowIndex,
          column: nextCellPosition.column,
          floating: previousCell.floating,
        }
        return result
      }
    },

    deleteRecord(record) {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete takeoff ?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete all information related this takeoff.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
      })
    },

    deleteAllRecord() {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete all information related these rows.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(null)
        },
      })
    },

    confirmDelete(record) {
      let url = null
      const ids = record ? [record.id] : this.selectedRowKeys
      switch (this.propData.screen) {
        case 'Building Shell':
          url = projectAPIs.project.asset.buildingShell.takeoff.delete(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Speciality Information':
          url = projectAPIs.project.asset.commonArea.takeoff.delete(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Interior Info':
          url = projectAPIs.project.asset.interiorInfo.takeoff.delete(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Site Takeoffs':
          url = projectAPIs.project.asset.siteTakeoff.takeoff.delete(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
      }
      this.loaderDelete = true
      instance
        .delete(url, { data: ids })
        .then(response => {
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          this.loaderDelete = false
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (!this.isValidTakeoff && this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.selectedRowKeys = []
          this.selectedRows = []
          if (
            this.propData.screen === 'Interior Info' &&
            this.propData.screen !== 'Tenant Interior Grouping'
          ) {
            this.$emit('updateBuildingFacts', {
              rowId: this.propData.firstRowValues.id,
              data: this.data,
              isSocket: true,
              isValidTakeoff: !this.isValidTakeoff,
            })
          } else {
            this.$emit(
              'updateTakeOff',
              this.data,
              false,
              this.propData.firstRowValues.id,
              !this.isValidTakeoff,
            )
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    addRecord() {
      this.loaderAdd = true
      let url = null
      switch (this.propData.screen) {
        case 'Building Shell':
          url = projectAPIs.project.asset.buildingShell.takeoff.add(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Speciality Information':
          url = projectAPIs.project.asset.commonArea.takeoff.add(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Interior Info':
          url = projectAPIs.project.asset.interiorInfo.takeoff.add(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Site Takeoffs':
          url = projectAPIs.project.asset.siteTakeoff.takeoff.add(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
      }
      instance
        .post(url)
        .then(response => {
          this.loaderAdd = false
          let newData = [...this.data]
          newData = newData.concat(_.get(response.data, 'result', []))
          newData.map(element => {
            element.area =
              this.propData.firstRowValues && this.propData.firstRowValues.area
                ? this.propData.firstRowValues.area
                : 0
            return element
          })
          this.data = [...newData]
          const itemsToAdd = addGridRecord(_.get(response.data, 'result', {}))
          // for add first time color default
          itemsToAdd.forEach(e => {
            e.isValidTakeoff = true
          })
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.gridOptions.api.redrawRows()
          const result = _.get(response.data, 'result', [])
          const indexOfNewRecord = this.data.findIndex(
            val => val.id === result.id,
          )
          this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
          this.gridOptions.api.startEditingCell({
            rowIndex: indexOfNewRecord,
            colKey: 'takeoff',
          })
          if (this.propData.screen === 'Interior Info') {
            this.$emit('updateBuildingFacts', {
              rowId: this.propData.firstRowValues.id,
              data: this.data,
              isValidTakeoff: !this.isValidTakeoff,
            })
          } else {
            this.$emit(
              'updateTakeOff',
              this.data,
              false,
              this.propData.firstRowValues.id,
              !this.isValidTakeoff,
            )
          }
        })
        .catch(err => {
          this.loaderAdd = false
          errorService(err)
        })
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.calculation = event.oldValue
          if (event.oldValue) {
            this.takeoffDetails.formula = convertCalculation(
              event.oldValue,
              this.propData,
              this.calculationData,
              this.propData['dropdownData'].calculation,
            )
          }
          const calculation = convertCalculation(
            event.value,
            this.propData,
            this.calculationData,
            this.propData['dropdownData'].calculation,
          )
          event.data['formula'] = calculation
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else if (evaluateQantity(event.data['formula']) === 'Error') {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else {
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              event.colDef.cellRendererParams.dataType,
              null,
              null,
              event.keyCode,
            )
          }
        } else {
          event.data.formula = undefined
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        }
      } else if (event.colDef.field === 'takeoff' && this.isBlurCalled) {
        if (event.value.length > 200) {
          showNotification(
            'error',
            'Takeoff',
            'Takeoff should consist of 200 characters only!',
          )
        } else {
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
            null,
          )
        }
      } else if (event.colDef.field === 'conditionFactor') {
        this.takeoffDetails = { ...event.data }
        this.takeoffDetails.conditionFactor = event.oldValue
        const isValid = validateNumber(
          event.value,
          'conditionFactor',
          'Condition Factor',
        )
        if (isValid) {
          window.previousValue = event.oldValue
          let factor = this.conditionFactorList.find(
            i => i.value === event.value,
          )
          if (!factor) {
            factor = {
              id: event.data.conditionFactorId,
            }
          }
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        }
      }
      this.isBlurCalled = true
    },

    showLoader(flag) {
      this.loading = flag
    },

    getWindowSize() {
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 200 + 'px'
      }
    },

    sortChanged(node) {
      this.tableState = this.gridOptions.columnApi.getColumnState()
      const isSortApplied = this.tableState
        .filter(
          i =>
            i.colId !== 'action' &&
            i.colId !== 'display' &&
            i.colId !== '0' &&
            i.colId !== 'isLocked',
        )
        .some(element => element.sort)
      if (!this.checked) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: isSortApplied || this.isArchive,
            },
          ],
        })
        let newData = [...this.data]
        newData = this.sortedData
        this.data = [...newData]
        if (this.propData.screen === 'Interior Info') {
          this.$emit('updateBuildingFacts', {
            rowId: this.propData.firstRowValues.id,
            data: this.data,
            isValidTakeoff: !this.isValidTakeoff,
          })
        } else {
          this.$emit(
            'updateTakeOff',
            this.data,
            false,
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
        }
        if (!this.checked) {
          this.updateColumnSetting()
        }
      }
    },

    onColumnResized(e) {
      if (e.finished && !this.checked) {
        this.updateColumnSetting()
      }
    },

    checkPerimeter() {
      if (this.propData && this.propData.screen === 'Speciality Information') {
        if (this.fieldLabel === 'Building') {
          this.fieldDisabled = true
        }
      } else if (this.propData && this.propData.screen === 'Site Takeoffs') {
        this.fieldDisabled = false
      } else if (this.propData && this.propData.screen === 'Interior Info') {
        if (!this.interiorGroupingId && this.tenantApproachId !== 2) {
          this.fieldDisabled = true
        } else if (
          !this.interiorGroupingId &&
          (this.structureProfileId === 1 || this.structureProfileId === 2)
        ) {
          this.fieldDisabled = true
        }
      }
    },

    cloneTakeoff() {
      this.loaderCopy = true
      let url = null
      const msg = 'Please wait while cloning the takeoffs'
      this.$root.$emit('popupUpdation', true, true, msg)
      let newData = [...this.data]
      switch (this.propData.screen) {
        case 'Building Shell':
          url = projectAPIs.project.asset.buildingShell.takeoff.clone(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Site Takeoffs':
          url = projectAPIs.project.asset.siteTakeoff.takeoff.clone(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Speciality Information':
          url = projectAPIs.project.asset.commonArea.takeoff.clone(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Interior Info':
          url = projectAPIs.project.asset.interiorInfo.takeoff.clone(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        default:
          break
      }
      const constData = [...this.propData.rows]
      instance
        .put(url, this.selectedRowKeys)
        .then(response => {
          _.get(response.data, 'result', []).forEach(element => {
            if (element.calculation) {
              element.formula = convertCalculation(
                element.calculation,
                this.propData,
                this.calculationData,
                this.propData.dropdownData.calculation,
              )
            }
            element.area =
              this.propData.firstRowValues && this.propData.firstRowValues.area
                ? this.propData.firstRowValues.area
                : 0
          })
          newData = newData.concat(_.get(response.data, 'result', []))
          this.loading = false
          this.loaderCopy = false
          this.data = [...newData]
          this.gridOptions.api.applyTransaction({
            add: _.get(response.data, 'result', []),
          })
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (!this.isValidTakeoff && this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.selectedRowKeys = []
          if (
            this.propData.firstRowValues &&
            this.propData.screen === 'Interior Info'
          ) {
            this.$emit('updateBuildingFacts', {
              rowId: this.propData.firstRowValues.id,
              data: newData,
              isValidTakeoff: !this.isValidTakeoff,
            })
          } else {
            this.$emit(
              'updateTakeOff',
              this.data,
              false,
              this.propData.firstRowValues.id,
              !this.isValidTakeoff,
            )
          }
        })
        .catch(err => {
          this.loading = false
          this.loaderCopy = false
          if (
            this.propData.firstRowValues &&
            this.propData.screen === 'Interior Info'
          ) {
            this.$emit('updateBuildingFacts', {
              rowId: this.propData.firstRowValues.id,
              data: constData,
              isValidTakeoff: !this.isValidTakeoff,
            })
          } else {
            this.$emit(
              'updateTakeOff',
              constData,
              false,
              this.propData.firstRowValues.id,
              !this.isValidTakeoff,
            )
          }
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },

    setActiveCell(key, index, keyCode) {
      const focusedCell = this.gridOptions.api.getFocusedCell()
      let focusKey
      if (focusedCell) {
        switch (key) {
          case 'contract':
            focusKey = 'categoryCode'
            break
          case 'categoryCode':
            focusKey = 'additionalDescription'
            break
          case 'additionalDescription':
            focusKey = 'takeoff'
            break
          case 'takeoff':
            focusKey = 'calculation'
            break
          case 'calculation':
            focusKey = 'quantity'
            break
          case 'quantity':
            focusKey = 'unit'
            break
          case 'unit':
            focusKey = 'unitCost'
            break
          case 'unitCost':
            focusKey = 'conditionFactor'
            break
          case 'conditionFactor':
            focusKey = 'multiplier'
            break
          case 'multiplier':
            if (index === this.data.length - 1) {
              if (keyCode === 9) {
                this.addRecord()
              }
            }
            break
          default:
            break
        }
        if (key !== 'multiplier') {
          this.gridOptions.api.setFocusedCell(index, focusKey)
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: focusKey,
          })
        }
      }
    },

    refreshColumns() {
      const columns = JSON.stringify(this.propData.columns)
      const displayColumns = JSON.parse(columns)
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle) {
          align = col.cellStyle.textAlign
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateLockRow(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
          col.filter = 'customFilter'
        }
        if (this.keys.includes(col.field)) {
          col.editable = params => {
            return (
              col.field !== 'action' && !params.data.isLocked && !this.isArchive
            )
          }
        } else if (!col.field && col.field === 'display') {
          col.editable = false
        } else {
          col.editable = false
        }
      })
      return displayColumns
    },

    resetRowData(index) {
      const newData = [...this.data]
      if (newData[index]) {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].area = this.propData.firstRowValues.area
      }
      newData[index].quantity = this.takeoffDetails.quantity
      newData[index] = this.takeoffDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
    },

    onRowDragEnd(e) {
      this.loading = true
      const request = []
      this.data.forEach((i, index) => {
        request.push({
          id: i.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      let url
      switch (this.propData.screen) {
        case 'Building Shell':
          url = projectAPIs.project.asset.buildingShell.takeoff.reorder(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Site Takeoffs':
          url = projectAPIs.project.asset.siteTakeoff.takeoff.reorder(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Speciality Information':
          url = projectAPIs.project.asset.commonArea.takeoff.reorder(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        case 'Interior Info':
          url = projectAPIs.project.asset.interiorInfo.takeoff.reorder(
            this.$route.params.id,
            this.propData.assetId,
            this.propData.firstRowValues.id,
          )
          break
        default:
          break
      }
      instance
        .patch(url, request)
        .then(response => {
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    resetGridConditionFactor(request) {
      const itemsToUpdate = updateConditionFactorGridRecord(
        this.gridOptions,
        request,
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
    },

    getColumnSettings(params, data) {
      const isValid = data.some(i => i.isLocked)
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.takeoff,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        const isPresent = tableState.find(i => i.colId === 'isValidTakeoff')
        if (!isPresent) {
          const element = {
            header: '',
            colId: 'isValidTakeoff',
            width: 5,
            hide: true,
            pinned: null,
            sort: null,
            sortIndex: null,
            aggFunc: null,
            rowGroup: false,
            rowGroupIndex: null,
            pivot: false,
            pivotIndex: null,
            flex: null,
          }
          tableState.push(element)
        }
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'isLocked',
            hide: !isValid,
          },
          {
            colId: 'display',
            hide: this.isArchive,
          },
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.takeoff,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    sortTakeoffs(value) {
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      let newData = [...this.data]
      if (value) {
        newData = _.orderBy(newData, ['isValidTakeoff'], ['asc'])
        this.data = newData
        this.gridOptions.api.setRowData(this.data)
      } else {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.takeoff,
        )
        newData = _.orderBy(newData, ['sequence'], ['asc'])
        if (columnDetails && columnDetails.columnDetails) {
          const tableState = JSON.parse(columnDetails.columnDetails)
          const isSort = tableState.some(i => i.sort)
          if (!isSort) {
            this.data = [...newData]
            this.gridOptions.api.setRowData(this.data)
          }
          this.getColumnSettings(this.gridOptions, this.data)
        } else {
          this.data = [...newData]
          this.gridOptions.api.setRowData(this.data)
        }
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: value || this.isArchive,
          },
        ],
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      if (this.isArchive) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )

      switch (this.propData.screen) {
        case 'Site Takeoffs':
        case 'Speciality Information':
        case 'Interior Info':
          this.$emit(
            'checkValidTab',
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
          break
        default:
          break
      }
    },
  },
}
